// extracted by mini-css-extract-plugin
module.exports = {"Card":"Error_Card__2SRGS","cardWrapper":"Error_cardWrapper__291b8","imgWrapper":"Error_imgWrapper__OPgkV","btn":"Error_btn__75SZ5"};